import { Dispatch } from 'redux';
import VisitedUrlEventTriggersController, {
  CreateEventTrigger,
  UpdateEventTrigger,
} from '../controllers/VisitedUrlEventTriggersController';
import commonHandler from '../errorHandlers/common-handler';
import { integrationsHandler } from '../errorHandlers/integrations-handler';
import { VisitedUrlEventTrigger } from '../model/VisitedUrlEventTriggerModel';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class VisitedUrlEventTriggersCRUDActions extends CrudActionContainer {
  constructor() {
    super('VISITED_URL_EVENT_TRIGGERS');
  }

  create(facebookPageId: number, visitedUrlEventTrigger: CreateEventTrigger) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));

      try {
        const response: VisitedUrlEventTrigger =
          await VisitedUrlEventTriggersController.create(
            facebookPageId,
            visitedUrlEventTrigger,
          );
        dispatch(this.retrieved(response));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(
          error,
          integrationsHandler(dispatch, this),
        );
      }
    };
  }

  retrieveById(facebookPageId: number, id: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAction));

      try {
        const response = await VisitedUrlEventTriggersController.getById(
          facebookPageId,
          id,
        );
        dispatch(this.retrieved(response));

        return response;
      } catch (error) {
        commonHandler(dispatch)(error);
      }
    };
  }

  retrieveAll(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const response = await VisitedUrlEventTriggersController.getAll(
          facebookPageId,
        );
        dispatch(this.retrievedAll(response));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }

  remove(facebookPageId: number, id: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.deleteAction));

      try {
        const response = await VisitedUrlEventTriggersController.remove(
          facebookPageId,
          id,
        );
        await dispatch(this.deleteLocal({ id }));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }

  update(facebookPageId: number, visitedUrlEventTrigger: UpdateEventTrigger) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));

      try {
        const response = await VisitedUrlEventTriggersController.update(
          facebookPageId,
          visitedUrlEventTrigger,
        );
        dispatch(this.retrieved(response));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }
}

const visitedUrlEventTriggersCRUDActions =
  new VisitedUrlEventTriggersCRUDActions();

export default visitedUrlEventTriggersCRUDActions;

export const useVisitedUrlEventTriggersCRUDActions = getActionHookBuilder(
  visitedUrlEventTriggersCRUDActions,
  ['retrieveAll', 'retrieveById', 'create', 'update', 'remove'],
);
